import { Link } from '@inertiajs/react'
import Seo from '../components/Seo'

export default function Unsubscribed({ ok, email }: { ok: boolean; email?: string | null }) {
  return (
    <>
      <Seo title="Unsubscribed" noindex />
      <div className="mx-auto max-w-md px-4 sm:px-6 py-24 text-center">
        <div className="mono-label mb-3">Newsletter</div>
        {ok ? (
          <>
            <h1 className="text-3xl font-semibold tracking-tight">You're unsubscribed</h1>
            <p className="mt-3 text-muted text-sm">
              {email ? <>{email} has</> : 'You have'} been removed from the Forma Sound newsletter.
              You won't receive any more marketing emails from us.
            </p>
            <p className="mt-2 text-muted text-sm">
              Changed your mind? You can re-subscribe any time by claiming a free pack.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-3xl font-semibold tracking-tight">Link expired or invalid</h1>
            <p className="mt-3 text-muted text-sm">
              We couldn't process that unsubscribe link. If you keep getting emails you don't want,
              just reply to one and we'll remove you.
            </p>
          </>
        )}
        <p className="mt-8 text-sm">
          <Link href="/" className="text-paper hover:underline">← Back to Forma Sound</Link>
        </p>
      </div>
    </>
  )
}
